export class StorageElementHeight {
    name: string;
    type: string | null;
    height: number;
    constructor(name: string, type: string | null, height: number) {
        this.name = name;
        this.type = type;
        this.height = height;
    }
}